module.exports = __webpack_public_path__ + "img/67.1ce1219d.jpg";